import {IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonText, IonLabel, IonIcon} from '@ionic/react';
import AuctionsGrid from '../components/AuctionsGrid';
import './Auctions.css';
import NavComponent from "../components/NavComponent";
import {flame} from "ionicons/icons";
import React from "react";
import {AuthUser} from "aws-amplify/auth";


const Auctions = ({user}: { user: AuthUser }) => {
    return (
        <div className={"bg-white"}>
            <IonPage className={"bg-white"}>
                <div className={"bg-white"}>
                    <IonContent fullscreen className={"bg-white"}>
                        <IonToolbar className={"bg-white"}>
                            <IonTitle>
                                <div className={"bg-white"}>
                                    <img src="assets/images/MADfreight-logo.png" alt="logo"/>
                                </div>
                            </IonTitle>
                            <NavComponent/>
                        </IonToolbar>
                        <IonItem className={"bg-white"}>
                            <IonLabel className={"bg-white"}>
                                <IonText color="secondary">
                                    <div>
                                        <p>BOOK NOW REQUIRES PROMPT SHIP</p>
                                        <p><span style={{color: "orange"}}><IonIcon style={{color: 'orange'}}
                                                                                    icon={flame}></IonIcon>HOT LOAD:</span> "TRUCKS
                                            THAT REQUIRE IMMEDIATE SHIPMENT".</p>
                                        <p><span style={{color: "blue"}}><img src="assets/rain.svg" alt="tarp required"
                                                                              style={{width: "25px"}}/>
                                    <span className="p-column-title">TARP REQUIRED</span></span> "TRUCKS THAT REQUIRE A
                                            TARP" </p>
                                    </div>
                                </IonText>
                            </IonLabel>
                        </IonItem>
                        <AuctionsGrid user={user}/>
                    </IonContent>
                </div>
            </IonPage>
        </div>
    );
};

export default Auctions;
